import React, { FunctionComponent, useState } from 'react'
import Row from './Row'
import { Divider, Text } from '@wework/dieter-ui'
import { RightArrow } from '../Icons'
import css from './CollapsingItem.module.scss'
import classnames from 'classnames'

interface CollapsingItemProps {
  title: string
  divider?: boolean
  isCollapsed?: boolean
  children?: Array<React.ReactNode>
}
const CollapsingItem: FunctionComponent<CollapsingItemProps> = ({
  title,
  children,
  divider = true,
  isCollapsed = true,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(!isCollapsed)
  return (
    <>
      {divider && <Divider light className={css.itemDivider} />}
      <Row className={css.titleGroup}>
        <Text className={css.title}>{title}</Text>
        <div
          onClick={() => setIsOpen(prevState => !prevState)}
          className={classnames(css.chevronButton, isOpen && css.open)}
        >
          <RightArrow />
        </div>
      </Row>
      {isOpen && children}
    </>
  )
}

export default CollapsingItem
